<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="getData"
      @setSampleReload="setSampleReload"
      @openEditPage="openEditSkuDialog"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('btn_select_sub_product') || '子件产品' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              v-if="allow('SA') && !disabled"
              @click="
                openEditSkuDialog({
                  pageType: 'add',
                  sampleCode: '',
                })
              "
            >
              {{ $l('btn_add_product') || '添加子件' }}
            </b-button>
            <b-button
              v-if="allow('SS') && !disabled"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="() => (chooseSampleDialogVisible = true)"
            >
              {{ $l('btn_add_choose') || '选择子件' }}
            </b-button>

            <el-badge
              v-if="allow('SR') && !disabled"
              :value="checkedCount"
              style="margin-bottom: 1px;"
              class="item"
            >
              <b-button
                v-if="allow('SR') && !disabled"
                size="sm"
                class="ml-2"
                variant="outline-danger"
                :disabled="!checkedCount"
                @click="remove()"
              >
                {{ $l('btn_add_remove') || '移除子件' }}
              </b-button>
            </el-badge>
          </div>
        </div>
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <EditSetSample
      :visible.sync="editSetSampleOpts.visible"
      :disabled="editSetSampleOpts.disabled"
      :title="editSetSampleOpts.title"
      :sampleCode="editSetSampleOpts.sampleCode"
      :sampleSetCode="sampleSetCode"
      :baseInfo="baseInfo"
      @reload="setSampleReload"
    />
    <ChooseSetSample
      v-if="chooseSampleDialogVisible"
      :visible.sync="chooseSampleDialogVisible"
      :sampleSetCode="sampleSetCode"
      type="checkbox"
      @confirm="onSampleConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main'
import BaseTable from '@/mixins/base-table'
import ChooseSetSample from '../choose-set-sample/dialog.vue'
import EditSetSample from '../edit-set-sample'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, EditSetSample, ChooseSetSample },
  mixins: [BaseTable, EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    sampleSetCode: { type: String, default: '' },
    baseInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      chooseSampleDialogVisible: false,
      editSetSampleOpts: {
        visible: false,
        sampleCode: '',
      },
    }
  },
  activated() {
    this.getData()
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData() {
      if (!this.sampleSetCode) return
      this.loading = true
      this.$api
        .sampleInfoSubProductListApi({
          sampleSetCode: this.sampleSetCode,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    remove() {
      if (!this.checkedRow || !this.checkedRow.length) {
        this.$message({
          message: '请选择需要移除的子件产品',
          type: 'warning',
        })
        return
      }
      this.$confirm(
        '是否要移除所选子件产品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        if (this.loadingOpen()) return
        const listCode = this.checkedRow.map((item) => item.sampleCode)
        const res = await this.$api
          .sampleInfoRemoveApi({ listCode, sampleSetCode: this.sampleSetCode })
          .catch(() => this.loadingClose())
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error('移除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '移除成功！',
          type: 'success',
        })
        this.setSampleReload()
        this.clearCheckboxRow()
      })
    },
    onSampleConfirm(data) {
      if (!data) return
      const listCode = data.map((i) => i.sampleCode)
      if (this.loadingOpen()) return
      this.$api
        .sampleInfoBindApi({
          listCode,
          sampleSetCode: this.sampleSetCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.setSampleReload()
            this.chooseSampleDialogVisible = false
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    setSampleReload() {
      this.getData()
      this.$emit('reload')
    },
    openEditSkuDialog({ pageType, sampleCode = '' }) {
      const types = {
        add: this.$l('dialog_title_sub_product_add') || '新增子件产品',
        edit: this.$l('dialog_title_sub_product_edit') || '编辑子件产品',
        detail: this.$l('dialog_title_sub_product_detail') || '子件产品详情',
      }
      this.editSetSampleOpts = {
        visible: true,
        title: types[pageType],
        sampleCode: sampleCode,
        disabled: pageType === 'detail',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
